// i18next key conventions for the sensor-naming catalog. Every leaf is an object with a
// `name` field, so each key builder resolves to the `.name` under its section.

/** Builds the i18next key for a unit category's display name. */
export function getUnitCategoryNameKey(unitCategory: string): string {
    return `unitCategories.${unitCategory}.name`;
}

/** Builds the i18next key for a sensor element's common (cluster-independent) display name. */
export function getSensorElementNameKey(sensorElementConfigKey: string): string {
    return `sensorElements.${sensorElementConfigKey}.name`;
}

/**
 * Builds the i18next key for a cluster-specific element-name override. `subChannel` disambiguates
 * elements that share a `sensorElementConfigKey` within the same cluster (e.g. two voltage
 * readings on different sub-channels) — see `SensorElementOutput.subChannel`.
 */
export function getClusterElementNameKey(
    sensorClusterConfigKey: string,
    sensorElementConfigKey: string,
    subChannel: number,
): string {
    return `sensorCluster.${sensorClusterConfigKey}.${sensorElementConfigKey}.${subChannel}.name`;
}
